// import { Button } from 'antd';
import Color from 'constants/color';
import styled, { css } from 'styled-components';

// Define the styled components outside of the CountdownButton component.
// Styled components
export const Button = styled.button<{ isActive: boolean }>`
  padding: 4px 12px; // smaller padding for a smaller button
  font-size: 12px; // smaller font size
  color: ${({ isActive }) =>
    isActive ? '#999' : '#333'}; // grey text for disabled state
  background-color: ${({ isActive }) =>
    isActive ? '#e7e7e7' : '#fff'}; // lighter grey for disabled state
  border: 1px solid ${({ isActive }) => (isActive ? '#ddd' : '#ccc')}; // subtle border change for disabled state
  border-radius: 8px;
  cursor: ${({ isActive }) => (isActive ? 'not-allowed' : 'pointer')};
  outline: none;
  transition: all 0.2s ease;
  box-shadow: ${({ isActive }) =>
    isActive
      ? 'none'
      : '0 2px 4px rgba(0, 0, 0, 0.1)'}; // subtle shadow for active state
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    background-color: ${({ isActive }) =>
      isActive
        ? '#e7e7e7'
        : '#f8f8f8'}; // a slight hover effect for active state
  }

  &:disabled {
    background-color: #f2f2f2;
    color: #ccc;
    cursor: not-allowed;
    box-shadow: none;
  }
`;

export const CountdownText = styled.span`
  font-weight: bold;
`;

export const TimestampText = styled.div`
  background-color: #ffffff; // white background for contrast
  color: #333333; // dark color for the text
  padding: 0px;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2); // shadow for dimension
  margin-top: 10px; // add space between the button and timestamp
  font-weight: bold;
  text-align: center;
  font-size: 10px;
`;
